import React, { useState, useEffect } from 'react';
import { userRequest } from '../../utils/requestMethods';

const FundSelector = ({
  schoolId,
  value,
  onChange,
  includeAllOption = false,
  excludeFundId = null,
  disabled = false,
  className = '',
  label,
  showBalance = true,
  autoSelectDefault = false,
}) => {
  const [funds, setFunds] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!schoolId) return;
    const fetchFunds = async () => {
      setLoading(true);
      try {
        const { data } = await userRequest.get(`/schools/${schoolId}/funds?limit=100`);
        const list = data?.funds || data?.data?.funds || [];
        setFunds(list);
        if (autoSelectDefault && !value && list.length > 0) {
          const defaultFund = list.find((f) => f.is_default) || list[0];
          if (defaultFund?._id) {
            onChange(defaultFund._id);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchFunds();
  }, [schoolId]);

  const options = excludeFundId ? funds.filter(f => f._id !== excludeFundId) : funds;

  return (
    <div>
      {label && <label className="block mb-1.5 text-sm font-medium text-gray-700">{label}</label>}
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled || loading}
        className={className || 'w-full rounded-xl bg-gray-50 border border-gray-200 px-4 py-2.5 text-sm font-medium text-gray-900 focus:border-indigo-500 focus:ring-indigo-500 focus:outline-none disabled:opacity-50'}
      >
        {includeAllOption && <option value="">All Funds</option>}
        {!includeAllOption && !value && <option value="" disabled>Select a fund</option>}
        {options.map(f => {
          const balStr = showBalance && f.balance?.availableBalance !== undefined && f.balance?.availableBalance !== null
            ? ` — ₦${parseFloat(f.balance.availableBalance || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            : '';
          return (
            <option key={f._id} value={f._id}>
              {f.name}{f.is_default ? ' (Default)' : ''}{balStr}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default FundSelector;
